// Mock data for Teng Food Holdings website

export const companyInfo = {
  holdingCompany: {
    name: "Teng Food Holdings Pte Ltd",
    uen: "202225393E",
    established: "21st July 2022",
    description: "Established to be the holding company of its three subsidiary companies and to operate a new cook-chill production facility.",
    address: "15 Senoko Drive #03-07/08 JTC Food Hub @ Senoko Singapore 758202",
    services: ["Cook Chill Food Manufacturing", "Retort Food", "Original Equipment Manufacturer (OEM) Services"]
  },
  subsidiaries: {
    firstCuisine: {
      name: "First Cuisine Food Industries Pte Ltd",
      uen: "200808067K",
      established: "6th March 2003",
      type: "Halal Food Manufacturing",
      description: "A halal food manufacturing company with over 20 years of expertise in the food supply industry.",
      services: ["Food services", "Retort food", "Original Equipment Manufacturer (OEM)"],
      premises: [
        {
          type: "Central Kitchen",
          address: "15 Senoko Drive #05-10 JTC Food Hub @ Senoko Singapore 758202",
          model: "cook-serve model"
        },
        {
          type: "Back up Kitchen",
          address: "3015 Bedok North Street 5 #06-20 Singapore 486350",
          model: "cook-serve model"
        }
      ],
      diets: ["Easy to Chew", "Soft and Bite Sized", "Minced and Moist", "Pureed", "Therapeutic Diet"],
      certifications: ["Basic Food Hygiene", "Advanced Food Hygiene Officer", "Eatsafe SG (IDDSI)"],
      rnd: {
        focus: "developing, testing, and enhancing food products for taste, safety, nutrition, shelf life, and sustainability",
        products: ["dumplings", "fish otah", "plant-based meat"]
      }
    },
    psCatering: {
      name: "PS Catering Pte Ltd",
      uen: "200919572Z",
      established: "20th October 2009",
      type: "Non-Halal Food Manufacturing",
      description: "Offers a wide variety of non-halal food services to institutional customers requesting such products.",
      address: "3015 Bedok North Street 5 #06-09 Singapore 486350",
      services: ["Wide variety of non-halal food services to institutional customers"]
    },
    fcIndustries: {
      name: "FC Food Industries Pte Ltd",
      uen: "201433430W",
      established: "8th November 2014",
      type: "Food Production",
      description: "Created to provide value-added services and produce a wide variety of products for institutional customers.",
      premises: [
        {
          type: "Bakery",
          address: "3015 Bedok North Street 5 #06-06 Singapore 486350",
          products: ["cakes", "buns", "Swiss roll", "cupcakes", "muffins", "sandwiches"]
        },
        {
          type: "Frozen Food Factory",
          address: "13 Tuas Bay Walk Singapore 637759",
          products: ["frozen food products"]
        }
      ]
    }
  }
};

export const therapeuticDiets = [
  {
    name: "Easy to Chew",
    description: "Foods that require minimal chewing effort while maintaining nutritional value and taste.",
    image: "https://images.unsplash.com/photo-1670165088652-a14639b1b1c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHx0aGVyYXBldXRpYyUyMGRpZXR8ZW58MHx8fHwxNzYwMDAzODAwfDA&ixlib=rb-4.1.0&q=85",
    characteristics: ["Soft texture", "Easy to bite", "Maintains shape", "Nutritionally balanced"]
  },
  {
    name: "Soft and Bite Sized",
    description: "Pre-cut, soft foods that are easy to manage and swallow safely.",
    image: "https://images.unsplash.com/photo-1625795839115-9fbb6226766a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHx0aGVyYXBldXRpYyUyMGRpZXR8ZW58MHx8fHwxNzYwMDAzODAwfDA&ixlib=rb-4.1.0&q=85",
    characteristics: ["Pre-cut portions", "Soft consistency", "Safe swallowing", "Appealing presentation"]
  },
  {
    name: "Minced and Moist",
    description: "Finely minced foods with added moisture for easier consumption.",
    image: "https://images.unsplash.com/photo-1629180050285-7c56c6671f19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHx0aGVyYXBldXRpYyUyMGRpZXR8ZW58MHx8fHwxNzYwMDAzODAwfDA&ixlib=rb-4.1.0&q=85",
    characteristics: ["Finely minced", "Moist texture", "Easy digestion", "Rich flavors"]
  },
  {
    name: "Pureed",
    description: "Smooth, pureed foods that require no chewing and are easy to swallow.",
    image: "https://images.unsplash.com/photo-1714383611441-8550122243ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHx0aGVyYXBldXRpYyUyMGRpZXR8ZW58MHx8fHwxNzYwMDAzODAwfDA&ixlib=rb-4.1.0&q=85",
    characteristics: ["Smooth consistency", "No lumps", "Easy swallowing", "Maintains nutrition"]
  }
];

export const facilities = [
  {
    name: "Senoko Drive (JTC Food Hub)",
    address: "15 Senoko Drive, JTC Food Hub @ Senoko, Singapore 758202",
    type: "Central Kitchens",
    capabilities: ["Cook-Serve Model", "Cook-Chill Model", "Large-scale Production"],
    description: "Our flagship facility featuring state-of-the-art central kitchens with both cook-serve and cook-chill capabilities."
  },
  {
    name: "Bedok North",
    address: "3015 Bedok North Street 5, Singapore 486350",
    type: "Multi-Purpose Facility",
    capabilities: ["Backup Kitchen", "Non-Halal Kitchen", "Bakery Production"],
    description: "Comprehensive facility housing our backup kitchen, specialized non-halal production, and bakery operations."
  },
  {
    name: "Tuas Bay Walk",
    address: "13 Tuas Bay Walk, Singapore 637759",
    type: "Frozen Food Factory",
    capabilities: ["Frozen Food Manufacturing", "Cold Chain Management", "Packaging"],
    description: "Dedicated frozen food production facility with advanced cold chain management systems."
  }
];

export const certifications = [
  {
    name: "Basic Food Hygiene",
    description: "Foundation certification ensuring proper food handling and hygiene practices",
    category: "Food Safety"
  },
  {
    name: "Advanced Food Hygiene Officer",
    description: "Advanced certification for food safety management and supervision",
    category: "Food Safety"
  },
  {
    name: "Eatsafe SG (IDDSI)",
    description: "International Dysphagia Diet Standardisation Initiative compliance for therapeutic diets",
    category: "Therapeutic Diets"
  },
  {
    name: "MOH Compliance",
    description: "Full compliance with Ministry of Health standards and regulations",
    category: "Regulatory"
  }
];

export const contactInfo = [
  {
    company: "Teng Food Holdings / Group Inquiries",
    address: "15 Senoko Drive #03-07/08 JTC Food Hub @ Senoko Singapore 758202",
    phone: "+65 6123 4567",
    email: "info@tengfoodholdings.sg",
    type: "Head Office"
  },
  {
    company: "First Cuisine General / Halal Manufacturing",
    address: "15 Senoko Drive #05-10 JTC Food Hub @ Senoko Singapore 758202",
    phone: "+65 6123 4568",
    email: "halal@firstcuisine.sg",
    type: "Halal Operations"
  },
  {
    company: "PS Catering (Non-Halal)",
    address: "3015 Bedok North Street 5 #06-09 Singapore 486350",
    phone: "+65 6123 4569",
    email: "nonhalal@pscatering.sg",
    type: "Non-Halal Operations"
  },
  {
    company: "FC Food Industries (Bakery)",
    address: "3015 Bedok North Street 5 #06-06 Singapore 486350",
    phone: "+65 6123 4570",
    email: "bakery@fcindustries.sg",
    type: "Bakery Operations"
  },
  {
    company: "FC Food Industries (Frozen Food)",
    address: "13 Tuas Bay Walk Singapore 637759",
    phone: "+65 6123 4571",
    email: "frozen@fcindustries.sg",
    type: "Frozen Food Operations"
  }
];

export const oemServices = {
  capabilities: [
    "End-to-end OEM manufacturing",
    "Product development and formulation",
    "Packaging and labeling services",
    "Quality assurance and testing",
    "Regulatory compliance support",
    "Supply chain management"
  ],
  advantages: [
    "Advanced automation for cost-effectiveness",
    "Halal and non-halal certification",
    "In-house R&D support",
    "Flexible production volumes",
    "Quick turnaround times",
    "Comprehensive quality control"
  ],
  productTypes: [
    "Retort food products",
    "Frozen food items",
    "Baked goods and confectionery",
    "Therapeutic and specialized diets",
    "Ready-to-eat meals",
    "Custom formulated products"
  ]
};